import React from 'react'
import { legalLinks } from '../../utils/consts'

const LicenseAgreement = () => {
	return (
		<div className='container'>
			<h1 className='text-xl md:text-2xl'>Юридическая информация</h1>

			<ul className='mt-10 space-y-2'>
				{legalLinks.map(link => (
					<li key={link.href}>
						<a href={link.href} className='link'>
							{link.title}
						</a>
					</li>
				))}
			</ul>
		</div>
	)
}

export default LicenseAgreement
